import * as React from "react";

function DataObjectPlus(props) {
  return (
    <svg width="16" height="16" style={props?.isDraggable ? {cursor: "not-allowed"} : {}} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="white"/>
    <path d="M4.5 8.32043L6.8479 10.7025L12.0504 5.5" stroke="#0D6F08" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export default DataObjectPlus;